export default {
    accountSettingsTitle: "Paramètres du compte",
    accountSettingsDescription: "Gérez vos préférences de compte et de sécurité",
    accountSettingsTabTitle1: "Profil",
    accountSettingsTabTitle2: "Thème",
    accountSettingsTabTitle3: "Sécurité",
    accountSettingsTabTitle4: "Souscription",
    accountSettingsSaveChangesActionLabel: "Enregistrer les modifications",
    accountInfoTitle: "Informations du compte",
    membershipInfoLabel: "Membre depuis",
    totalTestsLabel: "Tests effectués",
    totalStudyTimeLabel: "Heures d'étude",
    dangerZoneLabel: "Zone sensible",
    logoutActionLabel: "Déconnexion",
    deleteAccountActionLabel: "Supprimer le compte",
    deleteAccountDialogTitle: "Supprimer votre compte ?",
    deleteAccountDialogDescription: "Votre compte LinguaScore sera supprimé définitivement. Cette action est irréversible. Vous perdrez :",
    deleteAccountDialogItemProfile: "Votre profil et vos identifiants de connexion",
    deleteAccountDialogItemResults: "Votre historique de tests, vos réponses et vos résultats",
    deleteAccountDialogItemRecordings: "Vos enregistrements d'expression orale",
    deleteAccountDialogItemSubscription: "Le temps restant de votre abonnement",
    deleteAccountDialogPaymentNotice: "Les données de paiement sont conservées 7 ans, conformément à la réglementation financière.",
    deleteAccountPasswordPrompt: "Saisissez votre mot de passe pour confirmer",
    deleteAccountEmailPrompt: "Saisissez {{email}} pour confirmer",
    deleteAccountConfirmActionLabel: "Supprimer mon compte",
    themeTitle: "Thème de l'interface",
    lightThemeLabel: "Thème clair",
    darkThemeLabel: "Thème sombre",
    gorillaThemeLabel: "Thème Gorilla",
    preferredLanguageLabel: "Langue",
    preferredLanguageENOptionLabel: "Anglais",
    preferredLanguageENOptionDescription: "Interface et analyse des résultats en anglais tout en maintenant la langue de base de l'examen ciblé lors des entrainements et test blanc.",
    preferredLanguageFROptionLabel: "Français",
    preferredLanguageFROptionDescription: "Interface et analyse des résultats en français tout en maintenant la langue de base de l'examen ciblé lors des entrainements et test blanc.",

}
